import React from "react";
import { Link, useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();

  return (
    <nav className="bg-[#212739] border-b border-[#2d3346] sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center h-9">
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className={`py-1 text-xs tracking-wide uppercase border-b-2 transition-colors ${
                location.pathname === "/"
                  ? "text-[#f267bd] border-[#f267bd]"
                  : "text-gray-400 border-transparent hover:text-gray-200"
              }`}
            >
              Timer
            </Link>
            <Link
              to="/inventory"
              className={`py-1 text-xs tracking-wide uppercase border-b-2 transition-colors ${
                location.pathname === "/inventory"
                  ? "text-[#f267bd] border-[#f267bd]"
                  : "text-gray-400 border-transparent hover:text-gray-200"
              }`}
            >
              Inventory
            </Link>
            <Link
              to="/crafting"
              className={`py-1 text-xs tracking-wide uppercase border-b-2 transition-colors ${
                location.pathname === "/crafting"
                  ? "text-[#f267bd] border-[#f267bd]"
                  : "text-gray-400 border-transparent hover:text-gray-200"
              }`}
            >
              Crafting
            </Link>
            <Link
              to="/train"
              className={`py-1 text-xs tracking-wide uppercase border-b-2 transition-colors ${
                location.pathname === "/train"
                  ? "text-[#f267bd] border-[#f267bd]"
                  : "text-gray-400 border-transparent hover:text-gray-200"
              }`}
            >
              Train
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
